import { render, staticRenderFns } from "./JDRow.vue?vue&type=template&id=fced3db8&scoped=true&"
import script from "./JDRow.vue?vue&type=script&lang=js&"
export * from "./JDRow.vue?vue&type=script&lang=js&"
import style0 from "./JDRow.vue?vue&type=style&index=0&id=fced3db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced3db8",
  null
  
)

export default component.exports